module.exports = __webpack_public_path__ + "dimsans-webfont.2323108a0436002b406a.ttf";


//////////////////
// WEBPACK FOOTER
// /home/vatzcar/public_html/Exchange-NewsAdmin-Frontend/src/assets/fonts/dimsans-webfont.ttf
// module id = ../../../../../src/assets/fonts/dimsans-webfont.ttf
// module chunks = styles